@if (icon && tooltip && !insideControl) {
  <!-- a toggletip, so keyboard and touch users reach the message, and pressing shows it (ToggletipDirective). The whole
  chip is the button: with text, the text names it and Material adds the message as its description; an icon alone is
  named by the message (an identical name stops Material adding it again as a description) -->
  <button
    type="button"
    class="button-reset toggletip"
    [attr.aria-label]="text ? null : tooltip"
    [matTooltip]="tooltip"
    [matTooltipShowDelay]="500"
    matTooltipPosition="above">
    <mat-icon class="icon" [ngClass]="{ margin: margin }">{{ icon }}</mat-icon>
    <span class="caption">{{ text }}</span>
  </button>
} @else {
  @if (icon) {
    <mat-icon
      class="icon"
      matTooltipPosition="above"
      [matTooltip]="tooltip"
      [matTooltipShowDelay]="500"
      [matTooltipDisabled]="!tooltip"
      [ngClass]="{ margin: margin }">
      {{ icon }}
    </mat-icon>
  }
  <!-- inside a control the text is read as part of its name: the comma keeps it apart from the text before it -->
  @if (insideControl && text) {
    <span class="cdk-visually-hidden">, </span>
  }
  <span class="caption">{{ text }}</span>
}
<!-- inside a control (e.g. a panel header) the chip can't be a button: its message is hidden text, read with the control.
The comma keeps it apart from the text before it (a leading space would be dropped) -->
@if (tooltip && (insideControl || !icon)) {
  <span class="cdk-visually-hidden">, {{ tooltip }}</span>
}
